import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import './index.css';

const Layout = ({ children }) => (
    <div>
        <Helmet
            title={ 'Solmar Limpezas e Produtos de Higiene' }
            meta={[
                { name: 'description', content: 'A Solmar Limpezas é uma empresa de serviços de limpeza com um forte âmbito de atuação na região Norte do país. Vocacionada para a limpeza de diversos sectores, nomeadamente, empresarial, industrial e doméstico.' },
                { name: 'keywords', content: 'limpezas,produtos de higiene,' },
            ]}
            link={[
                { rel: 'stylesheet', type: 'text/css', charset:'UTF-8', href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css', },
                { rel: 'stylesheet', type: 'text/css', href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css', },
                { href:'https://fonts.googleapis.com/css?family=Playfair+Display', rel:'stylesheet' },
                { href: 'https://fonts.googleapis.com/css?family=Merienda', rel:'stylesheet' },
                { rel:'stylesheet', href:'https://fontlibrary.org/face/now', type:'text/css' }
            ]}
        />
        <div
            style={{
                margin: '0',
            }}>
            {children()}
        </div>
    </div>
);

Layout.propTypes = {
    children: PropTypes.func,
};

export default Layout;